import { motion } from "framer-motion";

const PageWrapper = ({ children }) => {

  return (
    <motion.div
      className="page-wrapper" // needed for scroll trick
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        minHeight: "100vh", // Ensure it fills container height
      }}
    >
      {children}
    </motion.div>
  );
};
export default PageWrapper;
